module.exports = __webpack_public_path__ + "img/img_franquicia.f93e8652.jpg";